import { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

const useSitePages = () => {
  const pageData = useStaticQuery(
    graphql`
      query {
        allSitePage(filter: { path: { regex: "/movies|tv/" } }) {
          edges {
            node {
              path
              pageContext
              id
            }
          }
        }
      }
    `
  );

  const sitePageMap = useMemo(
    () =>
      pageData.allSitePage.edges.reduce((acc, { node }) => {
        const {
          path,
          pageContext: { id },
        } = node;

        if (!acc.has(id) && id) {
          acc.set(id, path);
        }

        return acc;
      }, new Map()),
    [pageData]
  );

  return { sitePageMap };
};

export default useSitePages;
